export default __webpack_public_path__ + "static/media/ar_BH.1e919b85.svg";